<template>
  <div>
    <nav-bar :title="'New Rewards'"></nav-bar>
    <div class="mobile py-4">
      <div class="atm-desktop-max-width d-flex gap-4 flex-column justify-content-center mx-auto">
        <input
          type="text"
          v-model="rewardTitle"
          class="atm-input-title font-weight-600 w-100 mt-3"
          placeholder="Add title for new reward*"
          required
        />
        <input
          type="number"
          v-model="rewardCoins"
          class="atm-input border-left-0 w-100"
          placeholder="Coins required"
          required
        />
        <div class="my-2">
          <input-file
            :file="file"
            :imageMaxSize="imageMaxSize"
            :error="error"
            :fileInput="fileInput"
            @update:fileData="file = $event"
            @update:fileInput="fileInput = $event"
            @update:error="error = $event"
          >
          </input-file>
          <small class="text-muted d-block">
            Maximum image size 9 MB
          </small>
          <small v-if="error.value" class="text-danger d-block">
            {{ error.message }}
          </small>
        </div>
        <div class="d-flex align-items-center ">
          <input id="reUseCheckBox" type="checkbox" v-model="reUse" />
          <label for="reUseCheckBox" class="material-icons-round ml-0"></label>
          <label class="m-0">Allow reuse of this reward</label>
        </div>
        <button
          type="submit"
          class="atm-button bg-main mt-2 mb-4 w-50 mx-auto"
          @click="sendData"
          :disabled="isBeingSaved"
        >
          <b-spinner v-if="isBeingSaved" label="Save" />
          <span v-else>Save</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { NavBar } from '@/common/components';
import { setCreateReward } from '../services';
import { useSessionStore } from '@/common';
import { InputFile } from '@/common/components';

export default {
  data() {
    const imageMaxSize = 9437184;
    const sessionStore = useSessionStore();
    return {
      error: {},
      rewardTitle: null,
      rewardCoins: null,
      file: null,
      fileInput: null,
      reUse: true,
      imageMaxSize,
      sessionStore,
      isBeingSaved: false,
    };
  },
  components: {
    NavBar,
    InputFile,
  },
  computed: {
    userIsAParent() {
      return this.sessionStore.userIsAParent;
    },
    childId() {
      return this.userIsAParent ? this.sessionStore.childSelectedId : this.sessionStore.userId;
    },
  },
  methods: {
    saveFile(event) {
      this.file = event.target.files[0];
    },
    async sendData() {
      this.isBeingSaved = true;
      try {
        if (this.rewardTitle && this.rewardCoins && !this.error.value) {
            if (!this.file) {
              await this.createReward();
            } else {
              await this.createReward(this.file);
            }
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isBeingSaved = false;
      }
    },
    async createReward(imageData) {
      const formReward = {
        name: this.rewardTitle,
        child: this.childId,
        coins_required: this.rewardCoins,
        re_use: this.reUse,
        favorite: false,
      };
      if (imageData) {
        formReward.attachment = imageData;
      }
      try {
        await setCreateReward(formReward);
        this.$router.push({
          name: 'rewards',
          params: {
            markComplete: true,
          },
        });
      } catch (error) {
        console.error('rewardsForm', error);
      }
    },
  },
};
</script>
<style lang="scss">
.inputLabel {
  background-color: #f3f3f3;
  width: 100%;
  height: 50px;
  line-height: 50px;
  border-radius: 0.8rem;
  box-shadow: 2px 2px 6px rgb(0 0 0 / 25%);
  .nestedInput {
    display: none;
  }
}
.input-coin .input-group-text {
  background-color: #fff !important;
  border-right: 0 !important;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
